"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInviteDto = instanceOfInviteDto;
exports.InviteDtoFromJSON = InviteDtoFromJSON;
exports.InviteDtoFromJSONTyped = InviteDtoFromJSONTyped;
exports.InviteDtoToJSON = InviteDtoToJSON;
exports.InviteDtoToJSONTyped = InviteDtoToJSONTyped;
/**
 * Check if a given object implements the InviteDto interface.
 */
function instanceOfInviteDto(value) {
    if (!('identityId' in value) || value['identityId'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined)
        return false;
    if (!('facilityId' in value) || value['facilityId'] === undefined)
        return false;
    return true;
}
function InviteDtoFromJSON(json) {
    return InviteDtoFromJSONTyped(json, false);
}
function InviteDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'identityId': json['identityId'],
        'email': json['email'],
        'expiresAt': (new Date(json['expiresAt'])),
        'facilityId': json['facilityId'],
    };
}
function InviteDtoToJSON(json) {
    return InviteDtoToJSONTyped(json, false);
}
function InviteDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'identityId': value['identityId'],
        'email': value['email'],
        'expiresAt': ((value['expiresAt']).toISOString()),
        'facilityId': value['facilityId'],
    };
}
//# sourceMappingURL=InviteDto.js.map